import '../_app/jQuery-menu-aim';

window.grpMenuTimeouts = window.grpMenuTimeouts || [];
window.grpMenuOpenTimeouts = window.grpMenuOpenTimeouts || [];
window.grpMenuPopOver = window.grpMenuPopOver || null;
window.grpMenuPopOverId = window.grpMenuPopOverId || null;
window.configTimeoutReset = window.configTimeoutReset || null;

let _mainMenu = $('#mainMenu');
// const _showMainMenuDelay = 500;
// const _hideMainMenuDelay = 1000;
const _hidePopOverDelay = 600;
// const _configTimeoutResetDelay = 200;

let lastScrollTop = 0;
const delta = 5; // Próg przewijania

let _noAutoHide = false;
let _outOfMenu = false;
let _noOpenDelay = false;

const _popoverOptions = {
    html: true,
    content: function () {
        return $(this).siblings('[data-popover-content="true"]').html();
    },
    trigger: 'manual',
    delay: {
        show: 0,
        hide: 10000,
    },
    fallbackPlacements: ['right', 'left'],
    animation: true,
};

const _cleanTimeouts = () => {
    if (window.grpMenuTimeouts.length > 0) {
        let tm = window.grpMenuTimeouts.pop();
        while (typeof tm !== 'undefined') {
            clearTimeout(tm);
            tm = window.grpMenuTimeouts.pop()
        }
    }
};

const _cleanOpenTimeouts = () => {
    if (window.grpMenuOpenTimeouts.length > 0) {
        let tm = window.grpMenuOpenTimeouts.pop();
        while (typeof tm !== 'undefined') {
            clearTimeout(tm);
            tm = window.grpMenuOpenTimeouts.pop()
        }
    }
};

// const _delayedCleanConfig = () => {
//     if (window.configTimeoutReset !== null) {
//         _abortDelayedCleanConfig();
//     }
//     window.configTimeoutReset = setTimeout(() => {
//         _noOpenDelay = false;
//     }, _configTimeoutResetDelay);
// };


// hiding mainMenu if user scroll down more than menu height
const handleScroll = () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(lastScrollTop - st) <= delta) {
        return;
    }

    if (st > lastScrollTop && st > 650) {
        _hideMainMenu();
    }

    lastScrollTop = st;
}


const _abortDelayedCleanConfig = () => {
    if (window.configTimeoutReset !== null) {
        clearTimeout(window.configTimeoutReset);
        window.configTimeoutReset = null;
    }
};

const _hideAllGroupMenu = () => {
    _cleanOpenTimeouts();
    _hidePopOver();
    _cleanTimeouts();
    _mainMenu.find('[data-menu="group-menu"]').each(function () {
        $(this).closest('li').removeClass('show');
    });
    _abortDelayedCleanConfig();
};

const _hideMainMenu = () => {
    if (_mainMenu.hasClass('show')) {
        _mainMenu.find('.main-menu-item').removeClass('show')
        bootstrap.Collapse.getInstance(_mainMenu).hide()
    }
}

const _delayedHidePopOver = () => {
    if (window.grpMenuPopOver !== null && window.grpMenuPopOverId !== null) {
        window.grpMenuTimeouts.push(setTimeout(() => {
            _hidePopOver();
            if (_outOfMenu) {
                _hideAllGroupMenu();
                _outOfMenu = false;
            }
        }, _hidePopOverDelay));
    }
};

const _hidePopOver = () => {
    if (window.grpMenuPopOver !== null) {
        window.grpMenuPopOver.hide();
    }
    if (window.grpMenuPopOverId !== null) {
        $('#' + window.grpMenuPopOverId).removeClass('show');
    }
    window.grpMenuPopOver = null;
    window.grpMenuPopOverId = null;
};

const _showPopOver = (popover, targetId) => {
    if (window.grpMenuPopOverId !== null && window.grpMenuPopOverId !== targetId) {
        _hidePopOver();
    }
    window.grpMenuPopOver = popover;
    window.grpMenuPopOverId = targetId;
    window.grpMenuPopOver.show();
    $('#' + window.grpMenuPopOverId).addClass('show');
    $('.popover').each(function () {
        const el = $(this);
        el
            .off('mouseenter, mouseover')
            .on('mouseenter, mouseover', () => {
                _noAutoHide = true;
                _cleanTimeouts();
            })
            .off('mouseleave')
            .on('mouseleave', () => {
                _noAutoHide = false;
                _delayedHidePopOver();
            });
    });
};

const bind = () => {

    _mainMenu = $('#mainMenu');

    $('#mainMenu').on('show.bs.collapse', function () {
        $('.menu-background').toggleClass('active');
    });
    $('#mainMenu').on('hidden.bs.collapse', function () {
        $('.menu-background').toggleClass('active');
        _hideMainMenu();
    });

    $('.menu-background').on('click', function () {
        _hideMainMenu();
    })

    if (_mainMenu.length > 0) {
        //main groups
        _mainMenu.menuAim({
            activate: function (e) {
                const el = $(e);
                let count = 0;

                count = el.find('.main-menu-submenu-groups .submenu-group').length;
                el.find('.main-menu-submenu-groups .submenu-group').each(function () {
                    count += $(this).find('.sub-submenu-group-list .sub-submenu-item').length;
                });

                if (count <= 15) {
                    el.find('.main-menu-submenu-groups').css('columns', '1');
                } else if (count > 15 && count < 30) {
                    el.find('.main-menu-submenu-groups').css('columns', '3');
                } else {
                    el.find('.main-menu-submenu-groups').css('columns', '4');
                }

                el.addClass('show');
                const position = el.position();
                const elHeight = el.find('.main-menu-submenu').height();
                const elementPosition = (position.top - elHeight) - 2;

                if (elementPosition > 0 && elHeight < 500) {
                    if (elHeight < 560) {
                        if ($('.main-menu-item:last-child').get(0) === el.get(0)) {
                            el.find('.main-menu-submenu').css('top', elementPosition + 5);
                            el.find('.main-menu-submenu').addClass('rounded-top');
                        } else {
                            el.find('.main-menu-submenu').css('top', elementPosition);
                            el.find('.main-menu-submenu').addClass('rounded-top');
                        }
                    }
                } else {
                    if (position.top !== 0) {
                        el.find('.main-menu-submenu').addClass('rounded-bottom rounded-top');
                    }
                }
            },
            deactivate: function (e) {
                $(e).removeClass('show');
            },
            exitMenu: function (e) {
                if ($('.popover').length < 1) {
                    // setTimeout(() => {
                    $(e).find('.main-menu-item.show').removeClass('show');
                    // }, _hidePopOverDelay - 100);
                }
            }
        });

        //popoverGroups
        // _mainMenu.find('[data-menu="popover-menu"]').each(function () {
        //     const el = $(this);
        //     const elId = el.attr('id');
        //     const popover = new bootstrap.Popover(el, _popoverOptions);
        //     el.removeClass('show');
        //     el
        //         .off('mouseenter')
        //         .on('mouseenter', () => {
        //             _cleanTimeouts()
        //             _showPopOver(popover, elId);
        //         })
        //         .off('mouseleave')
        //         .on('mouseleave', () => {
        //             _cleanTimeouts()
        //             _delayedHidePopOver();
        //         })
        //         .find('.submenu-toggler')
        //         .off('click')
        //         .on('click', (e) => {
        //             _showPopOver(popover, elId);
        //             e.preventDefault();
        //             e.stopPropagation();
        //             return false;
        //         });
        // });

        //popoverGroups
        _mainMenu.find('.sub-submenu-item').each(function () {
            const el = $(this);
            const elementPopover = el.find('[data-menu="popover-menu"]');
            let elId = null;
            let popover = null;
            if (elementPopover.length > 0) {
                elId = elementPopover.attr('id');
                popover = new bootstrap.Popover(elementPopover, _popoverOptions);
                elementPopover.removeClass('show');
            }
            el
                .off('mouseenter')
                .on('mouseenter', () => {
                    _cleanTimeouts()
                    _hidePopOver();
                    if (elementPopover.length > 0) {
                        _showPopOver(popover, elId);
                    }
                })
                .off('mouseleave')
                .on('mouseleave', () => {
                    _cleanTimeouts()
                    _delayedHidePopOver();
                })
                .find('.submenu-toggler')
                .off('click')
                .on('click', (e) => {
                    _showPopOver(popover, elId);
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                });
        })

        if (_mainMenu.length > 0) {
            $(window).on('scroll', handleScroll)
        }

        $(window).on('resize', function () {
            if (_mainMenu.hasClass('show')) {
                if (window.innerWidth <= 1200) {
                    _hideMainMenu();
                }
            }
        })

    }
};

const resize = (withMainMenu) => {
    const top = $('.main-top-nav');
    const topContainerWidth = $('.container').innerWidth() || 1440;
    const mainMenuWidth = top.find('#mainMenu').innerWidth() || 356;
    const gap = 15;
    $('.main-menu-submenu').each(function () {
        const el = $(this);
        el.css('max-width', (topContainerWidth - mainMenuWidth - gap) + 'px');
    });
    if (typeof withMainMenu !== 'undefined' && withMainMenu) {
        const mainMenuItems = top.find('#mainMenu .main-menu-item');
        if (mainMenuItems.length > 0 && mainMenuItems.length !== 15) {
            const mainMenuHeight = top.find('#mainMenu').innerHeight() || 600;
            mainMenuItems.css('height', (mainMenuHeight / mainMenuItems.length) + 'px');
        }
    }
};

const load = () => {
    setTimeout(function () {
        $.get('/ajax/menu', {'menu': 'main'}).done(function (res) {
            $('ul#mainMenu').replaceWith(res.mainMenu);
        }).fail(function () {}).always(function () {
            resize();
            bind();
        });
    }, 2000);
}

export {
    bind,
    resize,
    load,
}
